import { request } from '@/utils';
export const getShareId = async (data: { id: string }): Promise<{ shareId: string }> => {
  return request({
    url: `/contracts/${data.id}/share`,
    method: 'GET'
  });
};
export const getShareInfo = async (data: { id: string }): Promise<any> => {
  return request({
    url: `/info/share/${data.id}`,
    method: 'GET'
  });
};

export const getShareRecipients = async (id: string, page: number): Promise<any> => {
  return request({
    url: `/info/share/${id}/recipients`,
    method: 'GET',
    params: { page }
  });
};

//{{apiHost}}/contracts/ES-oUvgKcL3Zm_teYAPaJj5f/mailto
export const sendMailToRecipients = async (data: { contractId: string; mailto: string }): Promise<any> => {
  return request({
    url: `/contracts/${data.contractId}/mailto`,
    method: 'POST',
    data
  });
};
